import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";

/**
 * Generated class for the AddorderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
	selector: "page-addorder",
	templateUrl: "addorder.html"
})
export class AddorderPage {
	constructor(public navCtrl: NavController, public navParams: NavParams) {}

	ionViewDidLoad() {
		console.log("ionViewDidLoad AddorderPage");
	}
}



// WEBPACK FOOTER //
// ./src/pages/addorder/addorder.ts